module.exports = __webpack_public_path__ + "static/media/Plain (1).f8c4c8ef.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Plain (1).ttf
// module id = 1177
// module chunks = 0 1 2 3 4 5 6 7